export function fixProductTaxons (product) {
  product.taxonsSort = {}
  if (product.taxons && !(product.taxons instanceof Array)) {
    product.taxons = Object.values(product.taxons)
      .reduce((p, c) => c instanceof Array ? p.concat(c) : p.concat([c]), [])
      .map(v => {
        if (typeof v === 'object') {
          product.taxonsSort[v.taxon] = v.pos
          v = v.taxon
        }
        return v
      })
  }
  return product
}

export function fixTaxon (taxon, parentCode = null) {
	const image = taxon.images[0];
	const headerImage = taxon.images.find(image => image.code == 'category_header');

	return {
		...taxon,
		parentCode,
		image: image ? image.path : '',
		headerImage: headerImage ? headerImage.path : '',
		children: taxon.children.map(childTaxon => {
			return fixTaxon(childTaxon, taxon.code)
		})
	}
}

export function fixProduct(c) {
	const image = c.images.find(image => image.code == 'shopmanager_product');
	const imageSpecial = c.images.find(image => image.code == 'shopmanager_product_special');
	const imageMood = c.images.find(image => image.code == 'shopmanager_product_mood');
	const imagesDetail = c.images.filter(image => image.code == 'shopmanager_product_detail');

	fixProductTaxons(c)

	return {
		tags: c.attributes?.reduce((p, c) => {
			if (c.code == "tags") {
				//TODO: we can remove this check in a future version
				if (!(c.value instanceof Array)) {
					throw new Error("productlist::readTags deprecated API")
				}
				p = p.concat(
					c.value.map(v => v["key"])
				)
			}
			return p
		}, []) || [],
		// add default stock
		stock: -1,
		dishEnabled: false,
		discountInPercent: true,
		averageRatings: 0,
		...c,

		image: image ? image.path : c.images.length && c.images[0].path || '',
		imageSpecial: imageSpecial ? imageSpecial.path : imagesDetail.length ? imagesDetail[0].path : '',//image ? image.path : c.images.length && c.images[0].path || '',
		imageMood: imageMood ? imageMood.path : '',
		imagesDetail: imagesDetail.length ? imagesDetail.map(i => i.path) : [image ? image.path : c.images.length && c.images[0].path || ''],

		originalPrice: c.originalPrice?.current,
		price: c.price?.current,

		variants: c.variants?.map(variant => {
			return {
				...variant,
				originalPrice: variant.originalPrice?.current,
				price: variant.price?.current,
				stock: variant.stock == null ? -1 : variant.stock
			}
		}) || []
	}
}

export function enhanceProducts(products, special) {
	return products.map((p, i) => {
		return {
			...p,
			special: special ? i == 0 : false,
			price: 0,
			selectedVariant: p.variants?.[0]?.code,
		}
	})
	.filter(product => product.stock != 0 && product.variants?.find(v => v.stock != 0) != null) // filter out products with 0 stock or any with only 0 variants
}

export function filterProductsByGroup(rootGetters) {
	const isLoggedIn = rootGetters['account/isLoggedIn']
	const accountGroupCodes = rootGetters['account/accountGroupCodes']

	return (product) => {
		if (product.customerGroups && product.customerGroups.length) {
			if (isLoggedIn && accountGroupCodes.length) {
				return product.customerGroups.reduce((acc, group) => {
					return accountGroupCodes.includes(group) || acc;
				}, false);
			}
			return false;
		}
		return true;
	}
}

export function filterProducts(rootGetters) {
	const filterIds = rootGetters['productlist/filtersActive']

	return (product) => filterIds.length > 0
		? filterIds.reduce((p, c) => p && product.tags.includes(c), true)
		: true
}
